/* eslint-disable */
export default {
  noResultFoundFor: 'Nenhum resultado encontrado para',
  foundFromServerHint:
    'Escreva a palavra-chave e prima Enter para pesquisar no {appName}',
  notResultFoundFromServer: 'Não foram encontrados resultados',
  loading: 'a carregar...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
